var React = require('react');

var ComponentRow = require('components/manage/pages/components/component_row');
var GroupComponentRow = require('components/manage/pages/components/group_component_row');

class ComponentStatuses extends React.Component {
  /*
   * ComponentStatuses Table, rendered on Dashboard and Incident Page
   *
   * @param {object} props
   * @param {object} props.page_param - Param of the owning page
   * @param {object} props.components - All components belonging to the page
   * @param {object} props.should_auto_update - Should we AJAX the component status updates? Or listen for form submit?
   * @param {object} props.component_statuses: List of all available statues and colors, provided in format:
   * {
   *   status_name: {label: 'status_name', name: 'Readable Status Name', color: '#hexcode'},
   *   ...
   * }
   */

  _componentsPresent() {
    return this.props.components.length > 0;
  }

  _buildComponentRows() {
    var rows = [];

    this.props.components.map(component => {
      if (component.is_group_parent) {
        rows.push(
          <GroupComponentRow key={component.id}
                             pageParam={this.props.page_param}
                             componentGroup={component}
                             componentStatuses={this.props.component_statuses}
                             shouldAutoUpdate={this.props.should_auto_update}/>
        );

      } else {
        rows.push(
          <ComponentRow key={component.id}
                        pageParam={this.props.page_param}
                        component={component}
                        componentStatuses={this.props.component_statuses}
                        shouldAutoUpdate={this.props.should_auto_update}/>
        );
      }
    });

    return <div> {rows} </div>;
  }

  _noComponentState() {
    return (
      <div className="table-row blank-state">
        <div>
          <strong>Sometimes downtime only affects one small part of your tech stack</strong>
        </div>
        <small>
          List those parts out here:
          <a href={Routes.page_components_path(this.props.page_param)}>&nbsp;Create a Component</a>
        </small>
      </div>
    );
  }

  render() {
    return (
      <div className="table-row-group component-statuses">
        { this._componentsPresent() ?  this._buildComponentRows() : this._noComponentState()}
      </div>
    );
  }
}

module.exports = ComponentStatuses;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/components/component_statuses.jsx